import React from "react";
import Reveal from "./Reveal";
import { RESULTS } from "../data/mock";

export default function Results() {
  return (
    <section className="section" id="results">
      <div className="container-x">
        <Reveal>
          <div className="text-center mb-12">
            <div
              className="font-script"
              style={{ fontSize: 22, color: "var(--agero-orange)" }}
            >
              (Results)
            </div>
            <h2
              className="font-display mt-3"
              style={{
                fontSize: "clamp(48px, 7vw, 110px)",
                letterSpacing: "-0.05em",
                lineHeight: 0.95,
              }}
            >
              Results
            </h2>
            <p
              className="mt-6 text-neutral-600 text-[18px] leading-relaxed mx-auto"
              style={{ maxWidth: 680 }}
            >
              One engagement. 349 days. No paid promotion. No engagement pods.
            </p>
          </div>
        </Reveal>

        <div className="flex flex-col gap-8">
          {RESULTS.map((r, idx) => (
            <Reveal key={r.id} delay={idx * 120} y={36}>
              <div
                className="work-card rounded-[32px] overflow-hidden relative"
                style={{
                  background:
                    "linear-gradient(135deg, #0A0A0A 0%, #1a0a05 60%, #2a0a02 100%)",
                  color: "#fff",
                }}
              >
              <div
                className="absolute inset-0 opacity-30 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(120% 80% at 110% 50%, rgba(255,51,1,0.45) 0%, rgba(255,51,1,0) 60%)",
                }}
              />
              <div className="relative grid lg:grid-cols-[1fr_1.2fr] gap-8 p-8 md:p-12">
                <div className="flex flex-col justify-between">
                  <div>
                    <div className="text-white/60 text-sm">
                      {r.id} <span className="opacity-60">/ 03</span>
                    </div>
                    <h3
                      className="font-display mt-6"
                      style={{
                        fontSize: "clamp(40px, 5vw, 76px)",
                        letterSpacing: "-0.04em",
                        lineHeight: 0.95,
                      }}
                    >
                      {r.title}
                    </h3>
                  </div>
                  <div className="flex flex-wrap gap-2 mt-8">
                    {r.tags.map((t) => (
                      <span
                        key={t}
                        className="px-4 py-1.5 rounded-full text-[13px] font-medium"
                        style={{
                          background: "rgba(255,255,255,0.08)",
                          border: "1px solid rgba(255,255,255,0.12)",
                          color: "#fff",
                        }}
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex items-center">
                  <p
                    className="text-white/85 leading-relaxed"
                    style={{ fontSize: "clamp(17px, 1.3vw, 21px)" }}
                  >
                    {r.body}
                  </p>
                </div>
              </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
